import React, { useEffect, useState } from "react";
import { MdOutlineHome } from "react-icons/md";
import { MdModeEdit } from "react-icons/md";
import TableSkeleton from "./TableSkeleton";
import axios from "axios";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import EditInputField from "./EditInputField";
import {
  storeDataInIndexedDB,
  fetchDataFromIndexedDB,
  updateDataInIndexedDB,
} from "../Hooks/IndexedDBUtils";
import { submitMeetingLog } from "../utils/offlineMeeting";
import ButtonLoader from "./ButtonLoader";
import { ANALYTICS_SOURCE } from "../constants";
import CommonSurveySelection from "./CommonSurveySelection";
import CustomModal from "./CustomModal";
import ScheduleMeet from "../Pages/ScheduleMeet";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DraggableAccordion } from "./drag-n-drop/draggableAccordion";
import { databaseAccordionField } from "./drag-n-drop/accordion-data";
import { UAParser } from "ua-parser-js";
const { REACT_APP_BASE_URL } = process.env;

const ContactTableDatabase = ({
  IDBtype,
  active,
  handleClick,
  allCount,
  dataProperty,
  checkedItems,
  handleCheckedItem,
  userData,
  filteredData,
  fetchDataBase,
  isDatabasePage,
  sortDatabaseFirstNameDescending,
  sortDatabaseFirstNameAscending,
  sortDatabaseLastNameDescending,
  sortDatabaseLastNameAscending,
  sortDatabaseAddressDescending,
  sortDatabaseAddressAscending,
  sortDatabaseZipDescending,
  sortDatabaseZipAscending,
  handleCheckedAll,
  loading,
  isAllCheckActive,
  db2,
  db3,
  syncableContactDB,
  syncableWolkingListDB,
  hiddenFields = [],
}) => {
  const [userId, setUserId] = useState("");
  const token = localStorage.getItem("token");
  const [meetingStartDate, setMeetingStartDate] = React.useState(null);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const profileEmail = localStorage.getItem("urserMail");
  const [meetingPost, setMeetingPost] = React.useState(null);
  const [meetingLoading, setMeetingLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [isFirstNameAscending, setIsFirstNameAscending] = useState(false);
  const [isLastNameAscending, setIsLastNameAscending] = useState(false);
  const [isAddressAscending, setIsAddressAscending] = useState(false);
  const [isZipCodeAscending, setIsZipCodeAscending] = useState(false);
  const [showMeetingLink, setShowMeetingLink] = useState(false);
  const [accordionData, setAccordionData] = useState([]);
  // Property visibility (see docs/implementation-plans/2026-09-15-property-visibility-survey-groups.md)
  // only governs the edit modal - the table always shows real values. The
  // `hiddenFields` prop comes from the parent's most recent fetch response;
  // this derives which of the currently-open record's own keys remain
  // visible so the accordion can skip rendering the hidden ones.
  const [visiblePropertyKeys, setVisiblePropertyKeys] = useState(null);
  const isFieldVisible = (name) => !hiddenFields.includes(name);
  const [formState, setFormState] = useState({
    firstname: "",
    middle_initial: "",
    lastname: "",
    email: "",
    canvasser_email: "",
    age: "",
    gender: "",
    marital_status: "",
    interested_in_a_chapter_meeting: false,
    individual_ethnic_categories: "",
    broad_ethnic_groupings: "",
    hispanic_country_origin: "",
    languages: "",
    landline_telephone: "",
    household_primary_language: "",
    cell_phone: "",
    residence_address_line_1: "",
    residence_address__continued_: "",
    residence_city: "",
    residence_state: "",
    residence_zip: "",
    education: "",
    occupation: "",
    occupation_industry: "",
    presence_of_children_code: "",
    residence_household_gender_composition: "",
    opt_in: "",
    political_party: "",
    national_voter_cluster: "",
    national_voter_subcluster: "",
    voter_registration_status: "",
    tracking_attempts: "",
    tracking_rating: "",
    tracking_conversion: "",
    tracking_contacted_voters: "false",
    hs_analytics_source: null,
    hs_analytics_first_touch_converting_campaign: "",
    hs_analytics_last_touch_converting_campaign: "",
    hs_email_sends_since_last_engagement: "",
    hs_email_last_email_name: "",
    hs_email_last_open_date: "",
    lifecyclestage: "",
    tracking_attempts_updated_time: null,
    tracking_conversion_updated_time: null,
    tracking_contacted_voters_updated_time: null,
    tracking_rating_updated_time: null,
    eitc_pre_qualification_status: "",
    do_you_make_less_than__64_000_: "",
    did_you_any_income_earn_income__including_cash__in_2021__2022__2023__: "",
    do_you_have_children_in_the_home_: "",
    have_you_ever_filed_for_earned_income_tax_credits_: "",
    eitc_sms_sequence: "false",
    eitc_email_sequence: "false",
    registration_status: "",
    dwelling_type: "",
    type_of_ballot_used: "",
    prfl_persuadable_voter: "",
    attempt_tracker: null,
  });

  const deviceLogInfo = UAParser();

  const currentDate = new Date();
  const today = currentDate?.toLocaleDateString("en-GB");
  const ownerID = localStorage.getItem("ownerId");
  const currentTime = new Date();
  const formattedDate = currentTime.toLocaleString("sv-SE").replace(" ", "T");

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
    setMeetingStartDate(formattedDate);
  }

  const handleEditClick = (user) => {
    openModal();
    setUserId(user?.id);
    const allKeys = Object.keys(user.properties || {});
    setVisiblePropertyKeys(new Set(allKeys.filter((key) => !hiddenFields.includes(key))));

    setFormState((prev) => {
      const updatedState = { ...prev };
      Object.keys(formState).forEach((key) => {
        if (user.properties.hasOwnProperty(key)) {
          updatedState[key] =
            user.properties[key] ||
            (typeof user.properties[key] === "boolean" ? "false" : "");
        }
      });
      return updatedState;
    });
  };

  const handleUpdateDate = () => {
    setFormState((prev) => ({
      ...prev,
      tracking_attempts_updated_time: today,
      tracking_conversion_updated_time: today,
      tracking_contacted_voters_updated_time: today,
      tracking_rating_updated_time: today,
    }));
  };

  const handleSendOnDoorKnock = async () => {
    if (!userId) {
      return;
    }
    const data = {
      id: userId,
      door_knocked_device: JSON.stringify(deviceLogInfo),
      last_door_knocked_by_user: ownerID,
    };
    const res = await axios.put(`${REACT_APP_BASE_URL}/database`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(res.data.message);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    try {
      const data = {
        id: userId,
        door_knocked_device: JSON.stringify(deviceLogInfo),
        last_door_knocked_by_user: ownerID,
        form_submitted_device: JSON.stringify(deviceLogInfo),
        form_submitted_by_user: ownerID,
        ...formState,
      };
      const storedSyncableContacts = await fetchDataFromIndexedDB(
        syncableContactDB,
        "syncableContactsStore"
      );
      const storedSyncableWalkingList = await fetchDataFromIndexedDB(
        syncableWolkingListDB,
        "syncableWalkingListStore"
      );

      if (navigator.onLine === false) {
        const updatedIndexData = {
          id: data?.id,
          properties: {
            ...data,
          },
        };
        delete updatedIndexData.properties.id;
        if (IDBtype === "contact") {
          if (storedSyncableContacts) {
            const filteredContacts = (storedSyncableContacts || []).filter(
              (entry) => entry.id !== data?.id
            );
            storeDataInIndexedDB(syncableContactDB, "syncableContactsStore", [
              ...filteredContacts,
              updatedIndexData,
            ]);
            toast.success("Contact list offline updated successfully!");
          } else {
            storeDataInIndexedDB(syncableContactDB, "syncableContactsStore", [
              updatedIndexData,
            ]);
            toast.success("Contact list offline updated successfully!");
          }
          setIsOpen(false);
        }
        if (IDBtype === "walking") {
          if (storedSyncableWalkingList) {
            const filteredWalkingList = (storedSyncableWalkingList || []).filter(
              (entry) => entry.id !== data?.id
            );
            storeDataInIndexedDB(
              syncableWolkingListDB,
              "syncableWalkingListStore",
              [...filteredWalkingList, updatedIndexData]
            );
            toast.success("walking list offline updated successfully! ");
          } else {
            storeDataInIndexedDB(
              syncableWolkingListDB,
              "syncableWalkingListStore",
              [updatedIndexData]
            );
            toast.success("walking list offline updated successfully! ");
          }
          setIsOpen(false);
        }
        await fetchDataBase(1, "RESET");
        updateDataInIndexedDB(
          db3,
          "walkingListStore",
          data?.id,
          updatedIndexData
        );
        updateDataInIndexedDB(
          db2,
          "databaseContactStore",
          data?.id,
          updatedIndexData
        );
      } else {
        const res = await axios.put(`${REACT_APP_BASE_URL}/database`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (res.data) {
          toast.success("Contact updated successfully!");
          await fetchDataBase(1, "RESET");
          closeModal();
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsSubmitLoading(false);
    }
  };
  const handleClose = (e) => {
    e.preventDefault();
  };

  const handleRatingChange = (e) => {
    setFormState((prev) => {
      return {
        ...prev,
        tracking_rating: parseInt(e),
      };
    });
  };

  const toggleFirstNameSortingOrder = () => {
    setIsFirstNameAscending((prevState) => !prevState);
    setIsLastNameAscending();
    setIsAddressAscending();
    setIsZipCodeAscending();
  };
  const toggleLastNameSortingOrder = () => {
    setIsLastNameAscending((prevState) => !prevState);
    setIsFirstNameAscending();
    setIsAddressAscending();
    setIsZipCodeAscending();
  };
  const toggleAddressSortingOrder = () => {
    setIsAddressAscending((prevState) => !prevState);
    setIsFirstNameAscending();
    setIsLastNameAscending();
    setIsZipCodeAscending();
  };
  const toggleZipCodeSortingOrder = () => {
    setIsZipCodeAscending((prevState) => !prevState);
    setIsFirstNameAscending();
    setIsLastNameAscending();
    setIsAddressAscending();
  };
  const handleMeetingLogSubmit = async (e) => {
    e.preventDefault();
    setMeetingLoading(true);
    try {
      if (
        userId &&
        meetingPost?.trim()?.length > 0 &&
        profileEmail &&
        ownerID
      ) {
        const data = {
          contactId: userId,
          startTime: meetingStartDate
            ? new Date(meetingStartDate).toISOString()
            : new Date().toISOString(),
          endTime: formattedDate ? new Date(formattedDate).toISOString() : null,
          outcome: "CANVASSED",
          title:
            "Door Meeting With " +
            formState?.firstname +
            " " +
            formState?.lastname,
          body: meetingPost,
          hubspotOwnerId: ownerID,
          location: "Doorstep",
          attendees: [profileEmail],
        };
        await submitMeetingLog(data, token)
          .then(({ offline, response }) => {
            toast.success(
              offline ? "Meeting saved offline!" : response?.data?.message || "Meeting set!"
            );
            setMeetingStartDate("");
            setMeetingPost("");
          })
          .catch((e) => {
            toast.error(e?.response?.data?.message || "Something went wrong");
          });
      } else {
        toast.error("Fields are missing");
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Something went wrong");
      toast.error(e?.message);
    } finally {
      setMeetingLoading(false);
    }
  };

  const formFields = [
    {
      name: "education",
      label: "Education",
      value: formState.education,
      type: "text",
      accordion: 1,
    },
    {
      name: "gender",
      label: "Gender",
      value: formState.gender,
      type: dataProperty?.find((data) => data?.name === "gender")?.fieldType,
      options: dataProperty?.find((data) => data?.name === "gender")?.options,
      accordion: 1,
    },
    {
      name: "occupation",
      label: "Occupation",
      value: formState.occupation,
      type: "text",
      accordion: 1,
    },
    {
      name: "age",
      label: "Age",
      value: formState.age,
      type: "text",
      accordion: 1,
    },
    {
      name: "occupation_industry",
      label: "Occupation Industry",
      value: formState.occupation_industry,
      type: dataProperty?.find((data) => data?.name === "occupation_industry")
        ?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "occupation_industry"
      )?.options,
      accordion: 1,
    },
    {
      name: "marital_status",
      label: "Marital Status",
      value: formState.marital_status,
      type: dataProperty?.find((data) => data?.name === "marital_status")
        ?.fieldType,
      options: dataProperty?.find((data) => data?.name === "marital_status")
        ?.options,
      accordion: 1,
    },
    {
      name: "residence_address_line_1",
      label: "Residence Address Line 1",
      value: formState.residence_address_line_1,
      type: "text",
      accordion: 2,
    },
    {
      name: "residence_address__continued_",
      label: "Residence Address Continued",
      value: formState.residence_address__continued_,
      type: "text",
      accordion: 2,
    },
    {
      name: "residence_city",
      label: "Residence City",
      value: formState.residence_city,
      type: "text",
      accordion: 2,
    },
    {
      name: "residence_state",
      label: "Residence State",
      value: formState.residence_state,
      type: "text",
      accordion: 2,
    },
    {
      name: "residence_zip",
      label: "Residence Zip",
      value: formState.residence_zip,
      type: "text",
      accordion: 2,
    },
    {
      name: "landline_telephone",
      label: " Landline Telephone",
      value: formState.landline_telephone,
      type: "text",
      accordion: 2,
    },
    {
      name: "individual_ethnic_categories",
      label: " Individual Ethnic Categories",
      value: formState.individual_ethnic_categories,
      type: dataProperty?.find(
        (data) => data?.name === "individual_ethnic_categories"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "individual_ethnic_categories"
      )?.options,
      accordion: 3,
    },
    {
      name: "broad_ethnic_groupings",
      label: " Broad Ethnic Groupings",
      value: formState.broad_ethnic_groupings,
      type: dataProperty?.find(
        (data) => data?.name === "broad_ethnic_groupings"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "broad_ethnic_groupings"
      )?.options,
      accordion: 3,
    },
    {
      name: "hispanic_country_origin",
      label: " Hispanic Country Origin",
      value: formState.hispanic_country_origin,
      type: "text",
      accordion: 3,
    },
    {
      name: "languages",
      label: "Languages",
      value: formState.languages,
      type: dataProperty?.find((data) => data?.name === "languages")?.fieldType,
      options: dataProperty?.find((data) => data?.name === "languages")
        ?.options,
      accordion: 3,
    },
    {
      name: "household_primary_language",
      label: " Household Primary Language",
      value: formState.individual_ethnic_categories,
      type: dataProperty?.find(
        (data) => data?.name === "household_primary_language"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "household_primary_language"
      )?.options,
      accordion: 3,
    },
    {
      name: "presence_of_children_code",
      label: "Presence of Children Code",
      value: formState.presence_of_children_code,
      type: dataProperty?.find(
        (data) => data?.name === "presence_of_children_code"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "presence_of_children_code"
      )?.options,
      accordion: 4,
    },
    {
      name: "residence_household_gender_composition",
      label: "Residence Household Gender Composition",
      value: formState.residence_household_gender_composition,
      type: dataProperty?.find(
        (data) => data?.name === "residence_household_gender_composition"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "residence_household_gender_composition"
      )?.options,
      accordion: 4,
    },
    {
      name: "political_party",
      label: "Political Party",
      value: formState.political_party,
      type: dataProperty?.find((data) => data?.name === "political_party")
        ?.fieldType,
      options: dataProperty?.find((data) => data?.name === "political_party")
        ?.options,
      accordion: 4,
    },
    {
      name: "national_voter_cluster",
      label: "National Voter Cluster",
      value: formState.national_voter_cluster,
      type: dataProperty?.find(
        (data) => data?.name === "national_voter_cluster"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "national_voter_cluster"
      )?.options,
      accordion: 4,
    },
    {
      name: "national_voter_subcluster",
      label: "National Voter Subcluster",
      value: formState.national_voter_subcluster,
      type: dataProperty?.find(
        (data) => data?.name === "national_voter_subcluster"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "national_voter_subcluster"
      )?.options,
      accordion: 4,
    },
    {
      name: "voter_registration_status",
      label: "Voter Registration Status",
      value: formState.voter_registration_status,
      type: dataProperty?.find(
        (data) => data?.name === "voter_registration_status"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "voter_registration_status"
      )?.options,
      accordion: 4,
    },
    {
      name: "registration_status",
      label: "Registration Status",
      value: formState.registration_status,
      type: dataProperty?.find((data) => data?.name === "registration_status")
        ?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "registration_status"
      )?.options,
      accordion: 4,
    },
    {
      name: "prfl_persuadable_voter",
      label: "PRFL PERSUADABLE VOTER",
      value: formState.prfl_persuadable_voter,
      type: "select",
      options: dataProperty?.find(
        (data) => data?.name === "prfl_persuadable_voter"
      )?.options,
      accordion: 4,
    },
    {
      name: "dwelling_type",
      label: "Dwelling Type",
      value: formState.dwelling_type,
      type: "text",
      options: dataProperty?.find((data) => data?.name === "dwelling_type")
        ?.options,
      accordion: 4,
    },
    {
      name: "type_of_ballot_used",
      label: "Type of ballot used",
      value: formState.type_of_ballot_used,
      type: "text",
      options: dataProperty?.find(
        (data) => data?.name === "type_of_ballot_used"
      )?.options,
      disabled: true,
      accordion: 4,
    },
    {
      name: "hs_analytics_source",
      label: "Original Source",
      value: formState.hs_analytics_source,
      type: "select",
      options: ANALYTICS_SOURCE,
      accordion: 5,
    },
    {
      name: "hs_analytics_first_touch_converting_campaign",
      label: "First Touch Converting Campaign",
      value: formState.hs_analytics_first_touch_converting_campaign,
      type: "text",
      disabled: true,
      accordion: 5,
    },
    {
      name: "hs_analytics_last_touch_converting_campaign",
      label: "Last Touch Converting Campaign",
      value: formState.hs_analytics_last_touch_converting_campaign,
      type: "text",
      disabled: true,
      accordion: 5,
    },
    {
      name: "hs_email_sends_since_last_engagement",
      label: "Sends Since Last Engagement",
      value: formState.hs_email_sends_since_last_engagement,
      type: "number",
      disabled: true,
      accordion: 5,
    },
    {
      name: "hs_email_last_email_name",
      label: "Last Marketing Email Name",
      value: formState.hs_email_last_email_name,
      type: "text",
      disabled: true,
      accordion: 5,
    },
    {
      name: "hs_email_last_open_date",
      label: "Last Marketing Email Open Date",
      value: formState.hs_email_last_open_date,
      type: "date",
      disabled: true,
      accordion: 5,
    },
    {
      name: "eitc_pre_qualification_status",
      label: "EITC pre-qualification status",
      value: formState.eitc_pre_qualification_status,
      type: dataProperty?.find(
        (data) => data?.name === "eitc_pre_qualification_status"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "eitc_pre_qualification_status"
      )?.options,
      accordion: 6,
    },
    {
      name: "have_you_ever_filed_for_earned_income_tax_credits_",
      label: "Have you ever filed for Earned Income Tax Credits?",
      value: formState.have_you_ever_filed_for_earned_income_tax_credits_,
      type: dataProperty?.find(
        (data) =>
          data?.name === "have_you_ever_filed_for_earned_income_tax_credits_"
      )?.fieldType,
      options: dataProperty?.find(
        (data) =>
          data?.name === "have_you_ever_filed_for_earned_income_tax_credits_"
      )?.options,
      accordion: 6,
    },
    {
      name: "do_you_make_less_than__64_000_",
      label: "Do you make less than $64,000?",
      value: formState.do_you_make_less_than__64_000_,
      type: dataProperty?.find(
        (data) => data?.name === "do_you_make_less_than__64_000_"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "do_you_make_less_than__64_000_"
      )?.options,
      accordion: 6,
    },
    {
      name: "did_you_any_income_earn_income__including_cash__in_2021__2022__2023__",
      label: "Did you any earn income, including cash, in 2021, 2022, or 2023?",
      value:
        formState.did_you_any_income_earn_income__including_cash__in_2021__2022__2023__,
      type: dataProperty?.find(
        (data) =>
          data?.name ===
          "did_you_any_income_earn_income__including_cash__in_2021__2022__2023__"
      )?.fieldType,
      options: dataProperty?.find(
        (data) =>
          data?.name ===
          "did_you_any_income_earn_income__including_cash__in_2021__2022__2023__"
      )?.options,
      accordion: 6,
    },
    {
      name: "do_you_have_children_in_the_home_",
      label: "Do you have children in the home?",
      value: formState.do_you_have_children_in_the_home_,
      type: dataProperty?.find(
        (data) => data?.name === "do_you_have_children_in_the_home_"
      )?.fieldType,
      options: dataProperty?.find(
        (data) => data?.name === "do_you_have_children_in_the_home_"
      )?.options,
      accordion: 6,
    },
    {
      name: "eitc_sms_sequence",
      label: "EITC SMS Sequence",
      value: formState.eitc_sms_sequence,
      type: "checkbox",
      accordion: 6,
    },
    {
      name: "eitc_email_sequence",
      label: "EITC Email Sequence",
      value: formState.eitc_email_sequence,
      type: "checkbox",
      accordion: 6,
    },
  ];

  const mapFormFieldsToAccordion = (formFields, accordionTemplate) => {
    const updatedAccordion = accordionTemplate.map((section) => ({
      ...section,
      content: [],
    }));

    formFields.forEach((field) => {
      const targetIndex = updatedAccordion.findIndex(
        (section) => section.id === field.accordion
      );
      if (targetIndex !== -1) {
        updatedAccordion[targetIndex].content.push(field);
      }
    });
    return updatedAccordion;
  };

  useEffect(() => {
    const visibleFields = visiblePropertyKeys
      ? formFields.filter((field) => visiblePropertyKeys.has(field.name))
      : formFields;
    const normalizedData = mapFormFieldsToAccordion(
      visibleFields,
      databaseAccordionField
    );
    setAccordionData(normalizedData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visiblePropertyKeys]);

  const handleInputChange = (e) => {
    if (e?.target?.type === "checkbox") {
      setFormState((prev) => ({
        ...prev,
        [e.target.name]: e.target.checked === true ? "true" : "false",
      }));
    } else {
      setFormState((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
    if (
      e.target.name === "tracking_contacted_voters" &&
      e.target.checked === true
    ) {
      setFormState((prev) => ({
        ...prev,
        tracking_attempts: e.target.checked === true ? "true" : "false",
      }));
    }

    if (e.target.name === "tracking_attempts" && e.target.checked === false) {
      setFormState((prev) => ({
        ...prev,
        tracking_contacted_voters: e.target.checked === true ? "true" : "false",
      }));
    }
    if (e.target.name === "tracking_attempts" && e.target.checked === true) {
      handleSendOnDoorKnock();
    }
    if (
      e.target.name === "tracking_attempts" ||
      e.target.name === "tracking_conversion" ||
      e.target.name === "tracking_contacted_voters" ||
      e.target.name === "tracking_rating"
    ) {
      handleUpdateDate();
    }
  };

  return (
    <div>
      {isAllCheckActive && (
        <p className="pl-5">
          All {active ? allCount : userData.length} rows on this page are
          selected.
          <button
            onClick={handleClick}
            className="text-canvas-primary font-bold underline"
          >
            &nbsp; {active ? "No " : `Select all ${allCount} `}&nbsp;
          </button>
          Select records.
        </p>
      )}
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="p-1.5 min-w-full inline-block align-middle">
            <div className="overflow-hidden">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-canvas-userbar">
                  <tr>
                    {isDatabasePage && (
                      <th
                        scope="col"
                        className="px-4 py-3 text-start text-xs text-canvas-secondery font-outfit font-bold flex flex-col gap-2 "
                      >
                        <input
                          className="tableCheckbox"
                          type="checkbox"
                          checked={isAllCheckActive}
                          onClick={handleCheckedAll}
                        />
                      </th>
                    )}

                    <th
                      scope="col"
                      className="px-4 py-3 text-start text-xs text-canvas-secondery font-outfit font-bold uppercase "
                    >
                      <div className="flex gap-1 items-center">
                        <p>First Name</p>
                        <button onClick={toggleFirstNameSortingOrder}>
                          {isFirstNameAscending ? (
                            <button onClick={sortDatabaseFirstNameDescending}>
                              <FaChevronUp className="h-4 w-4" />
                            </button>
                          ) : (
                            <button onClick={sortDatabaseFirstNameAscending}>
                              <FaChevronDown className="h-4 w-4" />
                            </button>
                          )}
                        </button>
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-start text-xs text-canvas-secondery font-outfit font-bold uppercase items-center"
                    >
                      <div className="flex gap-1 items-center">
                        <p> Last Name</p>
                        <button onClick={toggleLastNameSortingOrder}>
                          {isLastNameAscending ? (
                            <button onClick={sortDatabaseLastNameDescending}>
                              <FaChevronUp className="h-4 w-4" />
                            </button>
                          ) : (
                            <button onClick={sortDatabaseLastNameAscending}>
                              <FaChevronDown className="h-4 w-4" />
                            </button>
                          )}
                        </button>
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-start text-xs text-canvas-secondery font-outfit font-bold uppercase"
                    ></th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-start text-xs text-canvas-secondery font-outfit font-bold uppercase"
                    ></th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                    >
                      <div className="flex justify-center gap-2">
                        <p>Address</p>
                        <button onClick={toggleAddressSortingOrder}>
                          {isAddressAscending ? (
                            <button onClick={sortDatabaseAddressDescending}>
                              <FaChevronUp className="h-4 w-4" />
                            </button>
                          ) : (
                            <button onClick={sortDatabaseAddressAscending}>
                              <FaChevronDown className="h-4 w-4" />
                            </button>
                          )}
                        </button>
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                    >
                      <div className="flex justify-center gap-2">
                        <p>Zip Code</p>
                        <button onClick={toggleZipCodeSortingOrder}>
                          {isZipCodeAscending ? (
                            <button onClick={sortDatabaseZipDescending}>
                              <FaChevronUp className="h-4 w-4" />
                            </button>
                          ) : (
                            <button onClick={sortDatabaseZipAscending}>
                              <FaChevronDown className="h-4 w-4" />
                            </button>
                          )}
                        </button>
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                    >
                      <div className="flex justify-center gap-2">
                        <p>Political Party</p>
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                    >
                      <div className="flex justify-center gap-2">
                        <p>National Voter Cluster</p>
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                    >
                      <div className="flex justify-center gap-2">
                        <p>Email</p>
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                    >
                      Canvaser Email
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                    >
                      Home Phone
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-center text-xs text-canvas-secondery font-outfit font-bold uppercase"
                    >
                      Opt-in
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-canvas-primary/40">
                  {loading ? (
                    <TableSkeleton columns={isDatabasePage ? 13 : 12} />
                  ) : (
                    <>
                      {filteredData?.map((e, i) => (
                        <tr
                          className="hover:bg-canvas-primary/15 group/row text-canvas-primary transition-all"
                          key={i}
                        >
                          {isDatabasePage && (
                            <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-center">
                              <input
                                className="tableCheckbox"
                                type="checkbox"
                                checked={checkedItems.includes(e.id)}
                                onChange={() => handleCheckedItem(e.id)}
                              />
                            </td>
                          )}
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap">
                            <div className="text-xs flex gap-2 font-bold">
                              <p>{e?.properties.firstname}</p>
                            </div>
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap ">
                            <div className="text-xs flex gap-2 font-bold">
                              <p>{e?.properties.lastname}</p>
                            </div>
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap">
                            <Link
                              target="_blank"
                              to={`https://www.google.com/maps/search/${e?.properties?.residence_address_line_1},${e.properties.mailing_city}`}
                            >
                              <MdOutlineHome className="w-6 h-6 text-canvas-secondery group-hover/row:text-black transition-all" />
                            </Link>
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap flex items-center gap-5">
                            <button
                              type="button"
                              onClick={() => handleEditClick(e)}
                              // data-hs-overlay="#hs-basic-modal1"
                            >
                              <MdModeEdit className="w-6 h-6 text-canvas-secondary group-hover/row:text-black transition-all" />
                            </button>
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap font-outfit text-xs font-normal text-center">
                            {e?.properties?.residence_address_line_1}
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap font-outfit text-xs font-normal text-center">
                            {e?.properties?.residence_zip}
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                            {e?.properties.political_party}
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                            {e?.properties.national_voter_cluster}
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                            {e?.properties.email}
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                            {e?.properties.canvasser_email}
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                            {e?.properties?.cell_phone}
                          </td>
                          <td className="px-4 md:py-4 py-2 whitespace-nowrap text-xs font-outfit font-normal text-center">
                            {e?.properties?.opt_in === "true" ? "Yes" : "No"}
                          </td>
                        </tr>
                      ))}
                      {filteredData?.length === 0 && (
                        <tr>
                          <td
                            colSpan={isDatabasePage ? 13 : 12}
                            className="px-4 py-6 text-center text-sm font-outfit text-canvas-secondery"
                          >
                            No database records found.
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {userId && (
        <CustomModal
          open={modalIsOpen}
          onClose={closeModal}
          panelclassName="xl:max-w-6xl lg:max-w-5xl md:max-w-3xl max-w-2xl sm:w-full"
        >
          <h2 className="flex justify-center mb-1">Contact Details</h2>
          {formState?.lifecyclestage !== "subscriber" && (
            <div className="flex justify-center align-middle w-full ">
              <h4 className="text-center font-sans mb-1 text-[16px] bg-yellow-100 w-auto py-2 px-3 rounded-lg">
                This Contact Has Heard of The Connecticut Project
              </h4>
            </div>
          )}
          <form onSubmit={handleSubmit} noValidate>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 pb-3">
              {isFieldVisible("firstname") && (
                <EditInputField
                  label="First Name"
                  name="firstname"
                  value={formState?.firstname}
                  onChange={(e) => handleInputChange(e)}
                />
              )}
              {isFieldVisible("lastname") && (
                <EditInputField
                  label="Last Name"
                  name="lastname"
                  value={formState?.lastname}
                  onChange={(e) => handleInputChange(e)}
                />
              )}
              {isFieldVisible("cell_phone") && (
                <EditInputField
                  label="Cell Phone"
                  name="cell_phone"
                  value={formState?.cell_phone}
                  onChange={(e) => handleInputChange(e)}
                />
              )}
              {isFieldVisible("email") && (
                <EditInputField
                  label="Email"
                  name="email"
                  value={formState?.email}
                  onChange={(e) => handleInputChange(e)}
                />
              )}
              <CommonSurveySelection
                contactEmail={formState?.email}
                userId={userId}
              />
              {isFieldVisible("lifecyclestage") && (
                <EditInputField
                  label="Life Cycle Stage"
                  name="lifecyclestage"
                  value={formState?.lifecyclestage}
                  disabled={true}
                  onChange={(e) => handleInputChange(e)}
                  type={
                    dataProperty?.find((data) => data?.name === "lifecyclestage")
                      ?.fieldType
                  }
                  options={
                    dataProperty?.find((data) => data?.name === "lifecyclestage")
                      ?.options
                  }
                />
              )}
              <div className="flex items-end lg:pb-4">
                <button
                  type="button"
                  className="bg-gray-200 py-2 px-6 rounded w-full h-10 font-semibold"
                  onClick={() => setShowMeetingLink(true)}
                >
                  Meeting Link
                </button>
              </div>
              {isFieldVisible("tracking_contacted_voters") && (
                <EditInputField
                  label="Door Answered?"
                  name="tracking_contacted_voters"
                  value={formState?.tracking_contacted_voters}
                  onChange={(e) => handleInputChange(e)}
                  type="checkbox"
                />
              )}
              {isFieldVisible("tracking_conversion") && (
                <EditInputField
                  label=" Interested In 1:1 With An Organizer?"
                  name="tracking_conversion"
                  value={formState?.tracking_conversion}
                  onChange={(e) => handleInputChange(e)}
                  type="checkbox"
                />
              )}
              {isFieldVisible("interested_in_a_chapter_meeting") && (
                <EditInputField
                  label=" Interested In Attending a Chapter Meeting?"
                  name="interested_in_a_chapter_meeting"
                  value={formState?.interested_in_a_chapter_meeting}
                  onChange={(e) => handleInputChange(e)}
                  type="checkbox"
                />
              )}
              {isFieldVisible("opt_in") && (
                <EditInputField
                  label=" Cell Phone Opt-in"
                  name="opt_in"
                  value={formState?.opt_in}
                  onChange={(e) => handleInputChange(e)}
                  type="checkbox"
                />
              )}
              {isFieldVisible("tracking_attempts") && (
                <EditInputField
                  label=" Door Knocked?"
                  name="tracking_attempts"
                  value={formState?.tracking_attempts}
                  onChange={handleInputChange}
                  type="checkbox"
                />
              )}
              {isFieldVisible("tracking_rating") && (
                <EditInputField
                  label=" Tracking Rating"
                  name="tracking_rating"
                  value={formState?.tracking_rating}
                  onChange={handleRatingChange}
                  type="rating"
                />
              )}
              {isFieldVisible("attempt_tracker") && (
                <EditInputField
                  label=" Attempt Tracker"
                  name="attempt_tracker"
                  value={formState?.attempt_tracker}
                  // onChange={(e) => handleInputChange(e)}
                  type="text"
                  disabled={true}
                />
              )}
            </div>
            <div className="flex items-center gap-5 mt-6 pb-3">
              <button
                type="submit"
                disabled={isSubmitLoading}
                className="shadow bg-canvas-primary text-white font-bold py-2 px-4 rounded flex items-center gap-3"
              >
                {isSubmitLoading && <ButtonLoader />}
                Confirm Changes
              </button>
              <button
                type="button"
                className="bg-gray-200 py-2 px-6 rounded font-bold"
                onClick={closeModal}
              >
                Cancel
              </button>
            </div>
            <hr className="border-1 border-gray-400" />
            <div className="pb-3">
              <h2 className="flex justify-center py-1">Interaction Logging</h2>
              <form>
                <EditInputField
                  label="Conversation Notes"
                  name="meetingPost"
                  type="textarea"
                  rows={3}
                  value={meetingPost}
                  onChange={(e) => setMeetingPost(e.target.value)}
                  required={true}
                />
                <div className="flex items-center gap-5">
                  <button
                    type="submit"
                    className="shadow bg-canvas-primary text-white font-bold py-2 px-6 rounded flex items-center justify-center gap-3"
                    disabled={meetingLoading}
                    onClick={meetingPost && handleMeetingLogSubmit}
                  >
                    {meetingLoading && <ButtonLoader />}
                    Log Interaction
                  </button>
                  <button
                    type="button"
                    className="bg-gray-200 py-2 px-6 rounded font-bold"
                    onClick={(e) => closeModal(e)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
            <DndProvider backend={HTML5Backend}>
              <div className="hs-accordion-group w-full  gap-4">
                <DraggableAccordion
                  key={(visiblePropertyKeys ? [...visiblePropertyKeys] : formFields.map((f) => f.name)).join(",")}
                  accordionData={accordionData}
                  formState={formState}
                  formFields={formFields}
                  setFormState={setFormState}
                  handleInputChange={handleInputChange}
                  dataProperty={dataProperty}
                />
              </div>
            </DndProvider>
          </form>
        </CustomModal>
      )}
      <CustomModal
        open={showMeetingLink}
        onClose={() => setShowMeetingLink(false)}
        panelClass="xl:max-w-6xl lg:max-w-5xl md:max-w-3xl max-w-2xl sm:w-full"
      >
        <ScheduleMeet />
      </CustomModal>
    </div>
  );
};

export default ContactTableDatabase;
